import { faWallet } from '@fortawesome/pro-regular-svg-icons';
import { faChartLine } from '@fortawesome/pro-regular-svg-icons/faChartLine';
import { faClock } from '@fortawesome/pro-regular-svg-icons/faClock';
import { faDatabase } from '@fortawesome/pro-regular-svg-icons/faDatabase';
import { faLifeRing } from '@fortawesome/pro-regular-svg-icons/faLifeRing';
import { faPhoneLaptop } from '@fortawesome/pro-regular-svg-icons/faPhoneLaptop';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import clsx from 'clsx';

// Helpers
import useI18n from '@i18n';

// Styles
import styles from './Advantages.module.scss';

const Advantages: React.FC = () => {
    const { t } = useI18n('Cpa');

    return (
        <section className={styles.Advantages}>
            <div className={styles.landingContainer}>
                <h2 className={clsx([styles.blockTitle, styles.Advantages__title])}>
                    {t('Advantages')}
                </h2>

                <div className={styles.Advantages__items}>
                    <div className={styles.Advantages__card}>
                        <div className={styles.Advantages__cardIcon}>
                            <FontAwesomeIcon icon={faPhoneLaptop} />
                        </div>
                        <div className={styles.Advantages__cardTitle}>
                            {t('Technological solutions')}
                        </div>
                        <div className={styles.Advantages__cardContent}>
                            {t(
                                'Advanced traffic quality monitoring systems, platform that aggregates all information on clicks and sales.',
                            )}
                        </div>
                    </div>

                    <div className={styles.Advantages__card}>
                        <div className={styles.Advantages__cardIcon}>
                            <FontAwesomeIcon icon={faChartLine} />
                        </div>
                        <div className={styles.Advantages__cardTitle}>
                            {t('Traffic Monitoring')}
                        </div>
                        <div className={styles.Advantages__cardContent}>
                            {t(
                                'Source Tech security system that protects advertisers from potential fraud.',
                            )}
                        </div>
                    </div>

                    <div className={styles.Advantages__card}>
                        <div className={styles.Advantages__cardIcon}>
                            <FontAwesomeIcon icon={faLifeRing} />
                        </div>
                        <div className={styles.Advantages__cardTitle}>
                            {t('Individual technical support')}
                        </div>
                        <div className={styles.Advantages__cardContent}>
                            {t(
                                'Personal manager for support at all stages: from the institution of the office to the first sales',
                            )}
                        </div>
                    </div>

                    <div className={styles.Advantages__card}>
                        <div className={styles.Advantages__cardIcon}>
                            <FontAwesomeIcon icon={faClock} />
                        </div>
                        <div className={styles.Advantages__cardTitle}>
                            {t('Real-time statistics')}
                        </div>
                        <div className={styles.Advantages__cardContent}>
                            {t(
                                'Track sales in real time in the personal account of the advertiser.',
                            )}
                        </div>
                    </div>

                    <div className={styles.Advantages__card}>
                        <div className={styles.Advantages__cardIcon}>
                            <FontAwesomeIcon icon={faDatabase} />
                        </div>
                        <div className={styles.Advantages__cardTitle}>Own webmaster database</div>
                        <div className={styles.Advantages__cardContent}>
                            {t(
                                'We can find a webmaster for any affiliate program and desired traffic.',
                            )}
                        </div>
                    </div>

                    <div className={styles.Advantages__card}>
                        <div className={styles.Advantages__cardIcon}>
                            <FontAwesomeIcon icon={faWallet} />
                        </div>
                        <div className={styles.Advantages__cardTitle}>
                            Worldwide traffic sources
                        </div>
                        <div className={styles.Advantages__cardContent}>
                            Traffic can be directed from our webmasters worldwide
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Advantages;
